import React, { useState, useEffect } from 'react';
import { createModel } from 'hox';
import useGlobalModel from '@/model/globalModel';
import { assetsGetService } from '../../assetsGetService';
import { convertRes2Blob } from '@/utils/exportFile';
import { message } from 'antd';
import { useLockFn } from 'ahooks';
import {
	ISCMAssetsGetFormFields,
	ISCMAssetsGetInsert,
	ISCMAssetsGetUpdate,
	ISCMSDcGoodsDetail,
	ISCMSDcGoodsOne,
} from '../../assetsGetTypes';
import { globalPrompt } from '@/components/message';
import { ISCMSDcSelectGoods } from './AddGoodsModal';
import { CLIENT_APP_CODE } from '@/utils/constants';
import { formatNum, momentFormat } from '@/utils/utils';
import useNavModel from '@/model/navModel';
import { useDictModel } from '@/views/base/dict/dictModel';
import { debounce } from 'lodash';

export type ISCMSDcDescType = {
	numAll: number;
	amountAll: number;
	actualAmount: number;
	[key: string]: any;
};
const initDesc = {
	actualAmount: 0, //实际总价合计 （数量*单价）
	//对应展示字段
	numAll: 0, //调拨数量
	amountAll: 0, //调拨总计   （去除下浮）
};

export const useAssetsGetDetailsModel = createModel(function () {
	const {
		user: { userName }, fetchUserList, userData
	} = useGlobalModel();
	const { getSelectedDictValueOne, getSelectedDictOne, getTreeNodeName } = useDictModel(() => []);
	const initFormVal = {
		// createUser: userName,
		applier: userName,
		branchOut: CLIENT_APP_CODE,
		discountTotalAmount: '0.00', //优惠总额
		favorableAmount: '0', //整单优惠
		aggregateAmount: '0.00', //应付金额
		discountRate: '0', //整单下浮
	} as ISCMAssetsGetFormFields;
	const { selectedNavId, replaceNav, findNav } = useNavModel()
	//编辑缓存
	const [editFormVal, setEditFormVal] = useState<ISCMAssetsGetFormFields>(initFormVal);
	const [editGoodsList, setEditGoodsList] = useState<ISCMSDcGoodsDetail[]>([]);
	const [editDesc, setEditDesc] = useState<ISCMSDcDescType>(initDesc);

	//新增缓存
	const [addFormVal, setAddFormVal] = useState<ISCMAssetsGetFormFields>(initFormVal);
	const [addGoodsList, setAddGoodsList] = useState<ISCMSDcGoodsDetail[]>([]);
	const [addDesc, setAddDesc] = useState<ISCMSDcDescType>(initDesc);
	const [returnReceiveId, setReturnReceiveId] = useState<any>([]);
	// 控制先保存
	const [saveBtn, setSaveBtn] = useState<boolean>(false);
	// 保存按钮的loading效果
	const [saveBtnLoading, setSaveBtnLoading] = useState<boolean>(false);
	//导入点击
	const [changeImport, setChangeImport] = useState<boolean>(true)
	useEffect(() => {
		let newDesc: ISCMSDcDescType = { ...initDesc };
		editGoodsList.forEach((item) => {
			newDesc.numAll += Number(item.num);
			newDesc.amountAll += Number(item.amount);
			newDesc.actualAmount += Number(item.num) * Number(item.price);
		});
		setEditDesc(newDesc);
	}, [editGoodsList]);

	useEffect(() => {
		let newDesc: ISCMSDcDescType = { ...initDesc };
		addGoodsList.forEach((item) => {
			newDesc.numAll += Number(item.num);
			newDesc.amountAll += Number(item.amount);
			newDesc.actualAmount += Number(item.num) * Number(item.price);
		});
		setAddDesc(newDesc);
	}, [addGoodsList]);

	useEffect(() => {
		resetAddCatch();
		// setAddFormVal({ ...initFormVal, createUser: userName });
		setAddFormVal({ ...initFormVal });
	}, []);

	//表单新增修改
	const updateAddFormVal = (val: object | null) => {
		val ? setAddFormVal({ ...addFormVal, ...val }) : setAddFormVal(initFormVal);
	};
	//表单编辑修改
	const updateEditFormVal = (val: object | null) => {
		val ? setEditFormVal({ ...editFormVal, ...val }) : setEditFormVal(initFormVal);
	};

	//重置缓存
	const resetEditCatch = () => {
		updateEditFormVal(null); //表单
		setEditGoodsList([]); //详情商品列表
		setEditSelectGoods([]); //弹框已选商品
		setReturnReceiveId('')
	};
	const resetAddCatch = () => {
		updateAddFormVal(null);
		setAddGoodsList([]);
		setAddSelectGoods([]);
		setReturnReceiveId('')
	};

	//获取一条数据
	const getSDcDetailOne = async (id: string) => {
		let { retData } = await assetsGetService.one(id);
		let { details, ...formVal } = retData;
		if (retData) {
			setEditGoodsList(() => details.map((item) => ({ ...item, key: item.id, temporaryId: new Date().getTime() + Math.floor(Math.random() * 10000), })));
			let fileList: any = []
			const { md5, fileName } = formVal
			if (md5) {
				fileList = [
					{
						uid: md5,
						status: 'done',
						name: fileName,
						response: {
							retData: md5,
						},
					},
				]
			}
			formVal.fileList = fileList
			setEditFormVal({ ...formVal, createTime: momentFormat(formVal.createTime) ?? '' });
			fetchUserList(formVal.department)
		}
		return retData;
	};

	//表单物资校验 (开单数量不能为0)
	const verifyGoods = (mode: string): boolean => {
		let goods = mode === 'edit' ? editGoodsList : addGoodsList;
		if (!goods.length) {
			message.warning('请添加物品明细');
			return false;
		}
		let list = goods.filter((item) => item.materialName?.includes('笔记本电脑'))
		if (list.length > 0 && list.find(item => !item.user)) {
			message.warning('若物资名称中包含【笔记本电脑】，请填写当前使用人');
			return false;
		}
		let zeroNum = goods.filter((item) => !+item.num);
		if (zeroNum.length) {
			message.warning(
				`【${zeroNum.map((item) => item.materialName).join()}】物资的开单数量不能为0`
			);
			return false;
		}
		return true;
	};

	//新增 Api
	const insertSDc = useLockFn(async (val: ISCMAssetsGetFormFields) => {
		let unUse: any = [];
		addGoodsList.map((item) => {
			if (item.warehouseName == "闲置库") {
				unUse.push(item.materialCode)
			}
		})
		if (unUse.length > 0) {
			globalPrompt('modal', {
				title: '领取单保存提交',
				type: 'warning',
				text: `当前${unUse}为闲置库，是否确认提交？`,
				okText: '确认',
				onOk: debounce(async () => {
					setSaveBtnLoading(true);
					try {
						let data: ISCMAssetsGetInsert = {
							...val,
							details: addGoodsList,
							type: 'assets.receive'
						};
						let { retData } = await assetsGetService.insert(data);
						globalPrompt("message", { text: "物资领取新增成功", type: "success" })
						setSaveBtnLoading(false);
						replaceNav(selectedNavId, '2-2')
						resetAddCatch();
						return retData;
					} catch (error) {
						setSaveBtnLoading(false);
					}
				}, 500),
				cancelText: '取消',
				onCancel: () => { return },
			})
		}
		else {
			setSaveBtnLoading(true);
			try {
				let data: ISCMAssetsGetInsert = {
					...val,
					details: addGoodsList,
					type: 'assets.receive'
				};
				let { retData } = await assetsGetService.insert(data);
				globalPrompt("message", { text: "物资领取新增成功", type: "success" })
				setSaveBtnLoading(false);
				replaceNav(selectedNavId, '2-2')
				resetAddCatch();
				return retData;
			} catch (error) {
				setSaveBtnLoading(false);
			}
		}
	});

	//编辑 Api
	const updateSDc = useLockFn(async (val: ISCMAssetsGetFormFields & { id: string }) => {
		setSaveBtnLoading(true);
		try {
			let data: ISCMAssetsGetUpdate = {
				...val,
				id: editFormVal.id,
				details: editGoodsList,
				type: 'assets.receive'
			};
			let { retData } = await assetsGetService.update(data);
			globalPrompt("message", { text: "物资领取修改成功", type: "success" })
			setSaveBtnLoading(false);
			replaceNav(selectedNavId, '2-2')
			resetEditCatch()
			return retData;
		} catch (error) {
			setSaveBtnLoading(false);
		}
	});

	/**
	 * 商品新增
	 */
	const [addGoodsModal, setAddGoodsModal] = useState<boolean>(false); //商品弹框
	const [editSelectGoods, setEditSelectGoods] = useState<ISCMSDcSelectGoods[]>([]); //已选的商品
	const [addSelectGoods, setAddSelectGoods] = useState<ISCMSDcSelectGoods[]>([]); //已选的商品
	// 操作数据先保存
	const [buttonControl, setButtonControl] = useState<boolean>(false);

	//添加商品  默认数量字段为1
	const add = async (record: ISCMSDcSelectGoods, mode: string) => {
		const isEdit: boolean = mode === 'edit';
		isEdit
			? setEditSelectGoods((origin) => [...origin, { ...record, sDcNum: 1 }])
			: setAddSelectGoods((origin) => [...origin, { ...record, sDcNum: 1 }]);
	};

	//删除商品 选中的
	const remove = (record: ISCMSDcSelectGoods, mode: string) => {
		mode === 'edit'
			? setEditSelectGoods((origin) => origin.filter((item) => item.id !== record.id))
			: setAddSelectGoods((origin) => origin.filter((item) => item.id !== record.id));
	};

	//选中的物资转商品
	const transformsToSDcGoods = (async (selectList: ISCMSDcSelectGoods[], mode: string, type = 'add') => {
		if (mode === 'edit') {
			setButtonControl(true);
			setSaveBtn(true);
		}
		const isEdit: boolean = mode === 'edit';
		let codeList: string[] = [];
		let goodsList = mode === 'add' ? addSelectGoods : editSelectGoods;
		goodsList.forEach((item) => {
			codeList.push(item.materialCode);
		});
		let copyList: any = [];
		addGoodsList.forEach((list) => {
			copyList.push(list.materialCode);
		});
		if (type == 'add' && codeList.length === 0) {
			setAddGoodsModal(false)
			return
		}
		const newDetailData: any = [];
		selectList.forEach((item) => {
			if (copyList.includes(item.materialCode)) {
				return
			} else {
				console.log(copyList)
				newDetailData.push({
					materialCode: item.materialCode,
					barCode: item.barCode,
					materialName: item.materialName,
					model: item.model,
					typeCode: item.typeCode,
					typeName: item.typeName,
					code: item.code,
					price: item.price,
					unitCode: item.unitCode,
					unitName: item.unitName,
					detailsId: type == 'import' ? item.detailsId : item.id,
					num: item.num,
					warehouseName: item.warehouseName,
					amount: item.amount ?? item.price,
					warehouseCode: item.warehouseCode,
					shelfCode: item.shelfCode,
					note: "",
					temporaryId: new Date().getTime() + Math.floor(Math.random() * 10000),
					brandName: item.brandName,
					userCode: item.userCode ?? '',
					user: item.user ?? '',
					md5: item.md5,
					fileName: item.fileName
				});
			}
		});
		if (type == 'edit') {
			isEdit
				? setEditGoodsList((origin) => [...newDetailData])
				: setAddGoodsList((origin) => [...newDetailData]);
		}
		else {
			isEdit
				? setEditGoodsList((origin) => [...origin, ...newDetailData])
				: setAddGoodsList((origin) => [...origin, ...newDetailData]);
		}
		isEdit ? setEditSelectGoods([]) : setAddSelectGoods([]);
		setAddGoodsModal(false);
	});

	/**
	 * 打印
	 */
	const [print, setPrint] = useState<boolean>(false);
	const [historyVisible, setHistoryVisible] = useState<boolean>(false);
	const [historyRow, setHistoryRow] = useState<any>({});
	//下载模板
	const downloadTpl = async () => {
		let result = await assetsGetService.downloadTpl();
		convertRes2Blob(result)
	}
	return {
		editFormVal,
		addFormVal,
		addGoodsModal,
		setAddGoodsModal,
		updateAddFormVal,
		updateEditFormVal,
		resetEditCatch,
		resetAddCatch,
		/**api */
		insertSDc,
		updateSDc,
		getSDcDetailOne,
		/**商品详情 */
		editSelectGoods,
		setEditSelectGoods,
		addSelectGoods,
		setAddSelectGoods,
		addGoodsList,
		setAddGoodsList,
		editGoodsList,
		setEditGoodsList,
		add,
		remove,
		verifyGoods,
		editDesc,
		addDesc,
		print,
		setPrint,
		historyVisible,
		setHistoryVisible,
		historyRow,
		setHistoryRow,
		buttonControl,
		setButtonControl,
		saveBtn,
		setSaveBtn,
		saveBtnLoading,
		setSaveBtnLoading,
		transformsToSDcGoods,
		downloadTpl,
		changeImport,
		setChangeImport,
		returnReceiveId,
		setReturnReceiveId
	};
});
